<template>
<div>
    <v-card class="md-layout-item card">
      <v-container>
          <div>
            <div class="labels-container">
              <div class="row-label">
                <label class="md-body-1 bold-label" for="cid">Air Total</label>
                <label class="bold-value">{{this.totalNetAmount.toFixed(2)}}</label>              
              </div>
              <div class="row-label">
                <label class="md-body-1 bold-label" for="cid">Total Air Cost</label>
                <label class="bold-value">{{this.totalGrossAmount.toFixed(2)}}</label>              
              </div>
              <div class="row-label">
                <label class="md-body-1 bold-label" for="cid">Additional Services</label>
                <label class="bold-value">{{this.additionalCharges.toFixed(2)}}</label>              
              </div>              
              <div class="row-label">
                <label class="md-body-1 bold-label" for="cid">ATOL Charges</label>
                <label class="bold-value">{{this.invoice.aToL.toFixed(2)}}</label>              
              </div>
              <div class="row-label">
                <label class="md-body-1 bold-label" for="cid">Booking Fee</label>
                <label class="bold-value">{{this.bookingFeeAmount.toFixed(2)}}</label>              
              </div>
              <div class="row-label">
                <label class="md-body-1 bold-label" for="cid">Discount</label>
                <label class="bold-value">{{this.invoice.discount}}</label>              
              </div>
               <div class="row-label">
                <label class="md-body-1 bold-label" for="cid">Invoice Total</label>
                <label class="bold-value">{{this.invoiceTotal.toFixed(2)}}</label>              
              </div>
               <div class="row-label">
                <label class="md-body-1 bold-label" for="cid">Payment</label>
                <label class="bold-value">{{this.paymentReceived.toFixed(2)}}</label>              
              </div>
              <div class="row-label">
                <label class="md-body-1 bold-label" for="cid">Balance</label>
                <label class="bold-value">{{this.balance.toFixed(2)}}</label>              
              </div>
              <!-- SMS checkbox: only show on new invoices -->
              <div v-if="!invoice.fromServer" class="sms-checkbox-row">
                <v-divider style="margin: 10px 0 8px 0"></v-divider>
                <v-checkbox
                  v-model="sendSmsOnCreate"
                  label="Send SMS confirmation to customer"
                  color="teal"
                  dense
                  hide-details
                  class="mt-0 pt-0"
                ></v-checkbox>
              </div>
            </div>           
          </div>
      </v-container>
    </v-card>
    
</div>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { EventBus } from './../../eventbus/event-bus.js';
  import { mapState } from 'vuex'
  import _ from 'lodash';

  export default {
    name: 'billing-detail-panel',
    computed: {
      ...mapState('invoice', ['selectedInvoice','payment']),
      ...mapState('customers', ['selectedCustomer']),

      totalGrossAmount() {
        let sum = _.sumBy(this.invoice.passengers, function (passenger) {
          return parseFloat(passenger.gross); 
        });
        return sum;
      },
      totalNetAmount() {
        let sum = _.sumBy(this.invoice.passengers, function (passenger) {
          return parseFloat(passenger.netPrice); 
        });
        return sum;
      },
      invoice() {        
        return this.selectedInvoice;
      },
      additionalCharges() {        
        let sum = _.sumBy(this.invoice.services, function (service) {
          return parseFloat(service.charges); 
        });
        console.log(sum)
        return sum;
      },
      bookingFeeAmount() {
        return parseFloat(this.invoice.bookingFee || 0);
      },
      invoiceTotal() {        
        console.log("calculating invoiceTotal")
        return this.additionalCharges+this.totalGrossAmount+parseFloat(this.invoice.aToL)+parseFloat(this.bookingFeeAmount)-parseFloat(this.invoice.discount==null?0:this.invoice.discount);
      },
      invoiceCreator() {
        if (this.invoice.User) {
          return this.invoice.User.name;
        }        
        else {
          return this.user.name;
        }
      },
      preBalance() {
        if (this.selectedCustomer) {
          
          return parseFloat(this.selectedCustomer.balance?this.selectedCustomer.balance:0);
        }        
        else {
          return 0;
        }
      },
      balance() {        
        let projectedBalance = parseFloat(this.invoiceTotal)+parseFloat(this.preBalance)-parseFloat(this.paymentReceived)
        EventBus.$emit('projectedBalanceCalculated',projectedBalance);
        return projectedBalance;
      },
      paymentReceived() {
        let sum=0;
        if (this.invoice.id!=null) {
          sum = _.sumBy(this.invoice.invoicePayments, function (invoicePayment) {
            if (invoicePayment.amountCredit>0)
              return invoicePayment.amountCredit;
            else
              return -invoicePayment.amountDebit;
          });
        }      
        return sum + this.payment.amount;
      } 
    },
    mixins: [validationMixin],
    
    data: () => ({      
      suppliers: [],
      gdsValues: [],
      sendSmsOnCreate: false
    }),
    created () {
      // let self = this
    },
    watch: {
      selectedInvoice(newVal) {
        // Reset checkbox whenever an invoice from the server is loaded (editing mode)
        if (newVal && newVal.fromServer) {
          this.sendSmsOnCreate = false;
        }
      }
    },
    methods: {
    }
  }
</script>

<style lang="scss">
  .thead-container {
    height: auto !important;
    padding: 0px 0 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .td {
    height: 28px !important;
  }

</style>

<style scoped>
  .md-button {
    margin: 0px 0;
    height:auto;
  }
  .img-icons {
    height: 24px;
  }
  .menu-logo {
    height: 20px;
  }
  .table-remove-icon {
    min-width: auto
  }
  .md-toolbar.md-dense {
    min-height: 35px
  }
  .card {
    min-height: 170px !important;
    min-width: 250px
  }
  .v-container {
    padding-top: 0px;
    padding-bottom: 0px !important;
  }
  .row-label {
    align-content: space-between;
    display: flex;
    margin-bottom: 10px;
  }
  .bold-label {
    font-weight: 500;
    font-size: 17px;
  }
  .bold-value {
    margin-left:auto;
    font-weight: 500;
    font-size: 17px;
    color:#606060
  }
   .labels-container {         
    margin-top:10px;
  }
</style>